/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statistics_Day_Short_6Inputs */

const he_statistics_day_short_6 = /** @type {(inputs: Statistics_Day_Short_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ש`)
};

const en_statistics_day_short_6 = /** @type {(inputs: Statistics_Day_Short_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S`)
};

/**
* | output |
* | --- |
* | "S" |
*
* @param {Statistics_Day_Short_6Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const statistics_day_short_6 = /** @type {((inputs?: Statistics_Day_Short_6Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statistics_Day_Short_6Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_statistics_day_short_6(inputs)
	return en_statistics_day_short_6(inputs)
});